<div class="card mb-2" *transloco="let t">
    <div class="card-header">
      <h3>{{ t("What's Included with OK Alone") }}</h3>
    </div>
    <div class="card-body">
      <p>{{ t('When you signup to OK Alone you get the following included') }}</p>
      <table class="table table-striped">

          <tbody><tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('Monitoring for workers') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('Unlimited monitors') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('SMS, phonecalls and WhatsApp alerts emails to monitors') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('Apps for Android and iPhone') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('Safety Zone (geo fencing)') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('Safety Awards and Rankings') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('Handsfree status updates for Siri and Google Assistant') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('GPS Monitoring reports') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('Time sheet reports') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('High Risk check ins') }}</td></tr>
          <tr><td><i class="fa-solid fa-check text-success"></i></td><td>{{ t('Man Down monitoring') }}</td></tr>

                      </tbody></table>


      <br>
      <p><b>{{ t('Add the Communication Plan:') }}</b></p>
      <table class="table table-striped">
      <tbody><tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('Start shift reminders by SMS or WhatsApp') }}</td></tr>
      <tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('End shift reminders by SMS or WhatsApp') }}</td></tr>
      <tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('Check in reminders by SMS or WhatsApp') }}</td></tr>
      <tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('Check in reminders by phonecall') }}</td></tr>
      <tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('Send a SMS message to all workers') }}</td></tr>
      <tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('Alert loops') }}</td></tr>
      <tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('Out of Hours alerts') }}</td></tr>
      </tbody></table>
      <br>
      <p><b>{{ t('Add the Safety Monitoring Center Plan to get:') }}</b></p>
      <table class="table table-striped">
      <tbody><tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('Our Safety Monitoring Center can respond to any alerts 365 days a year') }}</td></tr>
      <tr><td><i class="fa-solid fa-check text-warning"></i></td><td>{{ t('We will review your escalation procedure') }}</td></tr>
      </tbody></table>


    </div>
  </div>
